import { render, staticRenderFns } from "./SideBarWithHoldings.vue?vue&type=template&id=02ba3bc5&scoped=true"
import script from "./SideBarWithHoldings.vue?vue&type=script&lang=js"
export * from "./SideBarWithHoldings.vue?vue&type=script&lang=js"
import style0 from "./SideBarWithHoldings.vue?vue&type=style&index=0&id=02ba3bc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ba3bc5",
  null
  
)

export default component.exports